export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#808080'
    },
    {
        nombre: 'Admin',
        color: '#495BFF'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]

export const ESTADOANUNCIOS = [
    {
        nombre: 'Publicado',
        color: '#495BFF'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },

]

export const ESTADOPRODUCTOS = [
    {
        nombre: 'En Stock',
        color: '#495BFF'
    },
    {
        nombre: 'Sin Stock',
        color: '#808080'
    },

]

export const ESTADOPEDIDOS = [
    {
        nombre: 'Nuevo',
        color: '#E40613'
    },
    {
        nombre: 'Seguimiento',
        color: '#ffc300'
    },
    {
        nombre: 'Enviado',
        color: '#495BFF'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },

]